export default __webpack_public_path__ + "static/media/team2.518b0f39.jpg";